<template>
  <div>
    <public-announcement :is-fixed="true" />
    <invitation-notifications v-if="$store.state.currentUser.id" />
    <edu-yearly-notification v-if="$store.state.currentUser.id" />
    <div
      v-if="showLoader"
      class="flex-grow flex items-center justify-center"
    >
    </div>
    <div v-else class="relative p-4 md:px-10 md:py-6">
      <OnboardingV3BackArrow />
      <div class="relative flex w-full border-b mb-4 border-secondary-20 items-center">
        <div class="flex-grow">
          <page-breadcrumb
            category="workspace"
            :text="getTeamname(currentAccount.name)"
            :title="'Team Members'"
            :noBorder="true"
          />
        </div>
        <div class="hidden sm:flex flex items-center flex-none">
          <div
            v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
          >
            <button
              type="button"
              class="aha-button m-2
              publish-presentation-btn aha-button-xl aha-button-primary"
              @click="showInviteMemberModal()"
            >
              <font-awesome-icon icon="user" size="sm" />
              <span>Invite member</span>
            </button>
          </div>
        </div>
      </div>

      <TeamPlanExpiryInfo
        v-if="currentAccount.createdFrom !== 'presenter'"
        :account="account"
        class="pb-5 lt-sm-devices--show"
      />
      <div class="row">
        <div class="flex sm:hidden">
          <div
            v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
          >
            <button
              type="button"
              class="aha-button
              publish-presentation-btn aha-button-xl aha-button-primary"
              @click="showInviteMemberModal()"
            >
              <font-awesome-icon icon="user" size="sm" />
              <span>Invite member</span>
            </button>
          </div>
        </div>
        <div class="announcement">
          <img src="@/assets/images/elements/gem.svg">
          <span>
            Allow more participants to join your team's events by
            <a
              class="cursor-pointer"
              @click="clickToGetAhaSlidesRequestTeamPlanUpgrade"
            ><b>requesting a team plan upgrade</b>.</a>
          </span>
        </div>
        <div class="col-12">
          <aha-section
            hasSubHeader
          >
            <template #header>
              <div class="flex items-center justify-between w-full">
                <h5 class="text-base-0">
                  My team
                </h5>
                <TeamPlanExpiryInfo
                  v-if="currentAccount.createdFrom !== 'presenter'"
                  :account="account"
                  class="sm-devices--show"
                />
              </div>
            </template>
            <template #sub-header v-if="currentUserIsTeamAdmin">
              <aha-tabs-primary @update:activeIndex="switchTabMyTeam">
                <aha-tab-item :title="getMembersTitle()" />
                <aha-tab-item :title="getInvitationsTitle()" />
              </aha-tabs-primary>
            </template>
            <template #body>
              <!-- MEMBERS TAB -->
              <div
                class="my-team__table-content-wrapper"
                v-if="tabIndex === 0 && !mobileViewDetailVisible"
              >
                <table class="team-table">
                  <colgroup>
                    <col
                      :class="{
                        'w-6/12': !currentUserIsTeamAdmin,
                        'sm:w-1/3': currentUserIsTeamAdmin
                      }"
                    >
                    <col
                      class="w-3/12"
                      :class="{
                        'sm-devices--show': currentUserIsTeamAdmin || isCasualUserNotHaveTeam,
                      }"
                    >
                    <col
                      class="w-1/12 sm-devices--show"
                      v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                    >
                    <col
                      class="w-3/12 sm-devices--show"
                      v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                    >
                    <col
                      class="w-1/12 sm-devices--show"
                      v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                    >
                    <col class="w-2/12">
                    <col
                      class="w-2/12"
                      :class="{'sm:d-none': !currentUserIsTeamAdmin}"
                    >
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        Name
                      </th>
                      <th class="sm-devices--show">
                        Email
                      </th>
                      <th
                        class="sm-devices--show"
                        v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                      >
                        Last activity
                      </th>
                      <th
                        class="sm-devices--show"
                        v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                      >
                        Joined
                      </th>
                      <th>
                        <span class="pl-3">
                          Role
                        </span>
                      </th>
                      <th />
                    </tr>
                  </thead>
                  <tbody v-if="teamMembers.length && !isLoadingTeamMembers">
                    <tr
                      :key="index"
                      v-for="(item, index) in teamMembers"
                    >
                      <td data-header="Name" class="team-table__truncate">
                        <span class="text-base-60">
                          {{ (currentPage - 1) * pageSize + index + 1 }}.
                        </span>
                        <span
                          class="font-bold"
                        >{{ item.firstName }} {{ item.lastName }}</span>
                        <span
                          v-if="item.id == $store.state.currentUser.id && !isCasualUserNotHaveTeam"
                          class="ml-1 text-base-70"
                        >
                          (You)
                        </span>
                      </td>
                      <td data-header="Email" class="sm-devices--show">
                        <a class="hover:text-primary-90" :href="`mailto:${item.email}`">
                          {{ item.email }}
                        </a>
                      </td>
                      <td
                        data-header="Last Activity"
                        class="sm-devices--show"
                        v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                      >
                        {{ item.lastActivity | dateTimeAgo }}
                      </td>
                      <td
                        class="date-ago sm-devices--show"
                        data-header="Joined"
                        v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
                      >
                        <span v-if="item.accountData">
                          {{ item.accountData.joinedAt | dateTimeAgo }}
                        </span>
                        <span v-else>{{ currentUser.createdAt | dateTimeAgo }}</span>
                      </td>
                      <td class="flex justify-start table-cell" data-header="Role">
                        <span class="pill-admin" v-if="item.accountRole === 'owner'">
                          Owner
                        </span>
                        <span v-else>
                          <member-role-selection
                            :member="item"
                            @updateMemberRole="updateMemberRole"
                          />
                        </span>
                      </td>
                      <td class="lt-sm-devices--show">
                        <team-kebab-menu
                          :member="item"
                          :memberIndex="index"
                          :currentUserIsTeamAdmin="currentUserIsTeamAdmin"
                          :isSelfCreateTeam="isSelfCreateTeam"
                          @openConfirmRemoveMember="openConfirmRemoveMember"
                          @openConfirmLeaveTeam="openConfirmLeaveTeam"
                          @handleShowViewDetail="handleShowViewDetail(item)"
                        />
                      </td>
                      <td
                        data-header=""
                        class="my-team__col-delete sm-devices--show"
                      >
                        <aha-icon
                          v-if="(item.email !== currentUser.email) && currentUserIsTeamAdmin
                            && isAllowToRemoveThisRole(item)"
                          name="close"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          class="cursor-pointer text-base-90"
                          v-tooltip="'Remove from team'"
                          @click="openConfirmRemoveMember(item)"
                        />
                        <aha-icon
                          v-if="(item.email === currentUser.email) && isSelfCreateTeam
                            && !hasOnboardingV3"
                          name="logout"
                          width="14"
                          height="14"
                          viewBox="3 0 16 24"
                          class="cursor-pointer text-base-90"
                          v-tooltip="'Leave team'"
                          @click="openConfirmLeaveTeam(item)"
                        />
                      </td>
                    </tr>
                    <tr v-if="teamMembers.length == 1" class="one-billing--row">
                      <td class="border-0" />
                    </tr>
                  </tbody>
                </table>
                <div
                  class="flex items-center justify-center h-8"
                  v-if="isLoadingTeamMembers"
                >
                  <aha-spinner />
                </div>
                <div class="flex justify-center mt-4" v-if="Math.ceil(totalMembers / pageSize) > 1">
                  <aha-pagination
                    v-model="currentPage"
                    :total-rows="totalMembers"
                    :per-page="pageSize"
                  >
                  </aha-pagination>
                </div>
                <div
                  v-if="!isLoadingTeamMembers"
                >
                  <h5
                    class="font-medium text-center text-red-100"
                    style="line-height: 35px;"
                    v-if="hasErrorGetTeamMembers"
                  >
                    Something went wrong. Please try again.
                  </h5>
                </div>
              </div>

              <!-- INVITATIONS TAB -->
              <div
                class="my-team__table-content-wrapper"
                v-if="tabIndex === 1 && !mobileViewDetailVisible"
              >
                <table class="team-table">
                  <colgroup>
                    <col class="w-2/12">
                    <col class="w-8/12">
                    <col class="w-1/12">
                    <col class="w-1/12">
                    <col class="w-1/12">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Invitation link</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody v-if="invitations.length">
                    <tr
                      :key="index"
                      v-for="(invitation, index) in invitations"
                    >
                      <td data-header="Email">
                        <a
                          class="hover:text-primary-90"
                          :href="`mailto:${invitation.invitedEmail}`"
                        >
                          {{ invitation.invitedEmail }}
                        </a>
                      </td>
                      <td
                        data-header="Invitation link"
                        class="my-team__col-invitation-link"
                        @click="copyLink(invitation.id)"
                      >
                        <input
                          type="text"
                          :id="`invitation-link-${invitation.id}`"
                          v-model="invitation.link"
                          class="invitation-link__input"
                        >
                        {{ invitation.link }}
                        <aha-icon
                          name="copy"
                          v-tooltip="'Copy'"
                          class="inline-block mb-1 text-base-60"
                        />
                      </td>
                      <td data-header="Role">
                        {{ getInvitationAccountRole(invitation.accountRole) }}
                      </td>
                      <td data-header="Status">
                        <span class="inline text-sm capitalize">
                          {{ getStatus(invitation.status) }}
                        </span>
                      </td>
                      <td class="my-team__col-delete">
                        <aha-icon
                          name="remove"
                          class="cursor-pointer text-base-90"
                          v-tooltip="'Withdraw invitation'"
                          title="'Withdraw invitation'"
                          @click="showWithdrawInvitationModal(invitation, index)"
                          v-if="invitation.status === 'pending'"
                        />
                      </td>
                    </tr>
                    <tr v-if="invitations.length === 1" class="one-billing--row">
                      <td class="border-0" />
                    </tr>
                  </tbody>
                </table>

                <div
                  class="flex items-center justify-center h-8"
                  v-if="isGettingInvitations"
                >
                  <aha-spinner />
                </div>

                <div
                  v-if="!isGettingInvitations"
                >
                  <h5
                    class="font-medium text-center"
                    style="line-height: 35px;"
                  >
                    <span v-if="isInvitationsTabAndNoInvitation && !hasErrorGetTeamMembers">
                      There are currently no pending, declined or expired invitations in your team.
                    </span>
                    <span v-if="hasErrorGetInvitations" class="text-red-100">
                      Something went wrong. Please try again.
                    </span>
                  </h5>
                </div>
              </div>
            </template>
          </aha-section>
        </div>
        <div
          v-if="teamMembers.length === 1"
          class="relative hidden sm:flex items-center justify-center text-center"
        >
          <img src="@/assets/images/team/girl-with-binoculars.png" width="125px">
          <span class="ml-4">
            You look lonely in here. Gather your team now by
            <span class="text-primary-100 cursor-pointer" @click="showInviteMemberModal()">
              <b>inviting members!</b>
            </span>
          </span>
        </div>
        <div
          v-if="teamMembers.length === 1"
          class="-mt-4 flex sm:hidden px-4 items-center"
        >
          <img src="@/assets/images/team/girl-with-binoculars.png" width="100px">
          <span class="ml-4">
            Don’t do it alone! Make a great team by
            <span class="text-primary-100 cursor-pointer" @click="showInviteMemberModal()">
              <b>inviting your members!</b>
            </span>
          </span>
        </div>
        <div
          class="relative mb-5 text-center"
          v-if="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
        >
          <div
            v-if="isWhiteLabel && !currentAccount.id"
            class="text-base-90"
          >
            <span v-if="currentUserIsTeamAdmin">For more licenses, please </span>
            <span v-if="isCasualUserNotHaveTeam">
              Want to use AhaSlides with your team? Please </span>
            <a
              class="my-team__footer-link"
              target="_blank"
              :href="myTeamFooterURL"
              @click="handleClickOnFooterTypeForm()"
            >speak to our Enterprise team</a>
          </div>
        </div>
      </div>
    </div>

    <modal-invite-new-member
      v-if="inviteMemberModalVisible"
      @hide="inviteMemberModalVisible = false"
      @updateInvitations="handleUpdateInvitationsAndLicense"
      :modalData="modalInviteMemberData"
    />
    <modal-remove-member
      v-if="removeMemberModalVisible"
      @hide="removeMemberModalVisible = false"
      @getTeamMember="getMyTeam()"
      :member="modalRemoveMemberData"
    />
    <modal-leave-team
      v-if="leaveTeamModalVisible"
      :mode="leaveModalMode"
      :teamName="currentAccount.name"
      @hide="leaveTeamModalVisible = false"
    />
    <modal-withdraw-invitation
      v-if="withdrawInvitationModalVisible"
      @hide="withdrawInvitationModalVisible = false"
      @updateInvitations="handleUpdateInvitationsAndLicense"
      :invitation="modalWithdrawInvitationData"
    />

    <TeamViewDetail
      v-if="mobileViewDetailVisible"
      :member="teamViewDetailData"
      :expiryInfo="account.planEndAt"
      :showAllDetail="currentUserIsTeamAdmin || isCasualUserNotHaveTeam"
      :isSelfCreateTeam="isSelfCreateTeam"
      @hide="mobileViewDetailVisible = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import Util from '@/util'
import configs from '@/config'
import AccountApi from '@/api/account'
import UserApi from '@/api/user'
import InvitationApi from '@/api/invitation'
import gaCategories from '@/constant/gaCategories'
import constants from '@/constant'

// UI
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import InvitationNotifications from '@/components-v2/common/global-notification/InvitationNotifications.vue'
import EduYearlyNotification from '@/components-v2/common/global-notification/EduYearlyNotification.vue'
import PageBreadcrumb from '../common/page-breadcrumb/PageBreadcrumb.vue'
import ModalInviteNewMember from '../modals/InviteNewMember.vue'
import ModalRemoveMember from '../modals/RemoveTeamMember.vue'
import ModalLeaveTeam from '../modals/LeaveTeam.vue'
import ModalWithdrawInvitation from '../modals/WithdrawInvitation.vue'
import TeamKebabMenu from './TeamKebabMenu.vue'
import TeamPlanExpiryInfo from './TeamPlanExpiryInfo.vue'
import TeamViewDetail from './TeamViewDetail.vue'
import OnboardingV3BackArrow from '../common/onboarding/OnboardingV3BackArrow.vue'
import MemberRoleSelection from './MemberRoleSelection.vue'
import EventBus from '@/eventBus'

export default {
  components: {
    PageBreadcrumb,
    ModalInviteNewMember,
    InvitationNotifications,
    ModalRemoveMember,
    ModalLeaveTeam,
    ModalWithdrawInvitation,
    TeamKebabMenu,
    TeamPlanExpiryInfo,
    TeamViewDetail,
    EduYearlyNotification,
    PublicAnnouncement,
    OnboardingV3BackArrow,
    MemberRoleSelection,
  },
  data() {
    return {
      account: {},
      teamMembers: [],
      hasErrorGetInvitations: false,
      hasErrorGetTeamMembers: false,
      isLoadingTeamMembers: false,
      isGettingInvitations: false,
      isGettingAccountInfo: false,
      invitations: [],
      tabIndex: 0,
      inviteMemberModalVisible: false,
      removeMemberModalVisible: false,
      leaveTeamModalVisible: false,
      leaveModalMode: 'member',
      withdrawInvitationModalVisible: false,
      modalInviteMemberData: {},
      modalRemoveMemberData: {},
      modalLeaveTeamData: {},
      modalWithdrawInvitationData: {},
      mobileViewDetailVisible: false,
      teamViewDetailData: {},
      currentPage: 1,
      pageSize: 50,
      totalMembers: 0,
      showLoader: true,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3 || null,
    }),
    isInvitationsTabAndNoInvitation() {
      return this.tabIndex === 1 && !this.invitations.length
    },
    myTeamFooterURL() {
      if (this.currentUserIsTeamAdmin) {
        return 'https://form.typeform.com/to/j2O9GXjI/?campaign=pricing?campaign=my-team-admin'
      }
      return 'https://form.typeform.com/to/j2O9GXjI/?campaign=my-team-newuser'
    },
    isCasualUserNotHaveTeam() {
      return this.currentUser && !this.currentUser.accountId
    },
    currentUserIsTeamAdmin() {
      return this.currentUser.accountId &&
       (this.currentUser.accountRole === constants.workspace.OWNER
          || this.currentUser.accountRole === constants.workspace.ADMIN)
    },
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
    isSelfCreateTeam() {
      return this.$store.state.currentAccount.createdFrom === 'presenter'
    },
  },
  watch: {
    '$store.state.currentUser': function handleTeamPageRedirect() {
      if (this.$store.state.currentUser.id) {
        this.getMyTeam()
      }
    },
    currentPage() {
      this.getMyTeam()
    },
    totalMembers(newVal) {
      if (newVal !== this.$store.state.currentAccount.totalMembers) {
        // make sure totalMembers true in 2 case: member accept
        // invitation, team lead remove 1 member out
        const account = this.$store.state.currentAccount
        this.setCurrentAccountAction({
          ...account,
          totalMembers: newVal,
        })
      }
    },
  },
  async created() {
    if (this.$router.query && this.$route.query.from === 'invitation') {
      // Accept invitation -> forcing accountRole is Member
      await this.getCurrentUserAction()
      this.showLoader = false
    } else {
      // Condition:
      // 1. No team, enter /team in browser -> redirect /presentations
      // 2. No team, create new team -> has team and redirected to /team
      // 3. Has team, login and reload team page: stay on team, not redirected
      // 4. No team, invited by someone else -> has team accept and redirect to invited team...
      setTimeout(() => {
        if (this.$route.query.from === 'invitation') {
          // C4.
          this.showLoader = false
          this.$router.replace({ query: null })
          window.location.reload()
        } else if (this.$store.state.currentUser &&
         !this.$store.state.currentUser.accountId
         && this.$route.query.from === undefined) {
          this.$router.push('/apps/presentations') // C1 but make sure not redirect in c4 case..
        } else this.showLoader = false // C2, C3
      }, 1000)
    }
  },
  mounted() {
    this.getMyTeam()
    this.getInvitations()
    this.triggerShowInviteMemberModalWithNewCreatedTeam()
  },
  methods: {
    ...mapActions([
      'setCurrentAccountAction',
      'getCurrentUserAction',
    ]),
    getTeamname(name) {
      if (!name) return 'Team Members'
      return Util.splitTeamName(name)
    },
    getMembersTitle() {
      let memberTabTitle = 'Members'
      if (this.totalMembers > 0) {
        memberTabTitle += ` (${this.totalMembers})`
      }
      return memberTabTitle
    },
    getInvitationsTitle() {
      return `Invitations (${this.invitations.length})`
    },
    getCurrentAccountRole(account) {
      return account.accountRole || 'Member'
    },
    switchTabMyTeam(tabIndex) {
      this.tabIndex = tabIndex
      const evtLabel = this.currentAccount.name || ''
      if (this.tabIndex === 0) {
        Util.gaTrackEvent(
          gaCategories.MY_TEAM,
          'Team Management > Open Members tab',
          evtLabel,
          '',
          {
            plan: this.currentUser.plan,
            isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
          },
        )
      } else if (this.tabIndex === 1) {
        Util.gaTrackEvent(
          gaCategories.MY_TEAM,
          'Team Management > Open Invitations tab',
          evtLabel,
          '',
          {
            plan: this.currentUser.plan,
            isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
          },
        )
      }
    },
    switchToInvitationsTab() {
      // use query selector because ref not work...
      const invitationTab = document.querySelectorAll('.aha-tab-title')[1] || {}
      if (invitationTab.classList && !invitationTab.classList.contains('active')) {
        invitationTab.click()
      }
    },
    async getMyTeam() {
      this.isLoadingTeamMembers = true
      this.isGettingAccountInfo = true
      this.hasErrorGetTeamMembers = false
      if (!this.$store.state.currentUser.id) {
        return
      }

      try {
        const res = await UserApi.getTeamMembers({
          userId: this.currentUser.id,
          page: this.currentPage,
          size: this.pageSize,
        })
        const { totalUsers, users } = res
        this.teamMembers = users
        this.totalMembers = totalUsers
        if (this.isCasualUserNotHaveTeam) {
          this.currentUser.accountRole = 'owner'
          this.isGettingAccountInfo = false
          return
        }
        this._getAccountById()
      } catch (error) {
        this.hasErrorGetTeamMembers = true
        Util.gaTrackEvent('My Team', 'Get user team', 'Get user plan failed')
        throw error
      } finally {
        this.isLoadingTeamMembers = false
      }
    },

    async _getAccountById() {
      if (!this.currentUser.id) return

      try {
        this.account = await AccountApi.getAccountById(this.currentUser.accountId)
      } catch (error) {
        if (error.status === 403) {
          window.localStorage.setItem(constants.workspace.WORKING_MODE,
            constants.workspace.PERSONAL)
          this.$store.state.workingMode = constants.workspace.PERSONAL
          this.setCurrentAccountAction({})
          this.$router.push({ name: 'Presentations' })
        } else {
          Sentry.captureException(error)
        }
      } finally {
        this.isGettingAccountInfo = false
      }
    },

    async getInvitations() {
      this.hasErrorGetInvitations = false
      try {
        this.invitations = await InvitationApi.getInvitations()
        this._createInvitationLinks()
      } catch (error) {
        this.hasErrorGetInvitations = true
        Sentry.captureException(error)
      }
    },

    _createInvitationLinks() {
      this.invitations.forEach((invitation) => {
        invitation.invitedPlan = invitation.invitedPlan.replace('-', ' ')
        invitation.link = `${configs.presenterDomain}/pages/register?invite-code=${invitation.id}`
      })
    },
    triggerShowInviteMemberModalWithNewCreatedTeam() {
      const { newTeam } = this.$route.query
      if (newTeam && this.currentUser.id % 2 === 1) {
        setTimeout(() => {
          if (this.currentUser.id % 2 === 1) this.showInviteMemberModal()
          else return
          this.$router.replace({
            query: {},
          })
        }, 1000)
      } else {
        this.$router.replace({
          query: {},
        })
      }
    },
    showInviteMemberModal() {
      this.modalInviteMemberData = {
        numberOfUsedLicenses: this.isCasualUserNotHaveTeam ? 1 : this.account.numberOfUsedLicenses,
        licenseQuantity: this.isCasualUserNotHaveTeam ? 1 : this.account.licenseQuantity,
        isCasualUserNotHaveTeam: this.isCasualUserNotHaveTeam,
        myTeamFooterURL: this.myTeamFooterURL,
        planEndAt: this.account.planEndAt,
      }
      this.inviteMemberModalVisible = true
      Util.gaTrackEvent(
        gaCategories.MY_TEAM,
        'Team Management > Invite member > Show Invite new member dialogue',
        this.currentUser.accountRole === 'owner' ? 'Owner' : 'Casual user',
        '',
        {
          plan: this.currentUser.plan,
          isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
        },
      )
    },
    async showWithdrawInvitationModal(invitation, index) {
      this.modalWithdrawInvitationData = invitation
      invitation.index = index
      this.withdrawInvitationModalVisible = true
      Util.gaTrackEvent(
        gaCategories.MY_TEAM,
        'Team management > Invite member > Click Withdraw',
        invitation.invitedEmail,
        '',
        {
          plan: this.currentUser.plan,
          isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
        },
      )
    },

    handleClickOnFooterTypeForm() {
      if (this.currentUserIsTeamAdmin) {
        Util.gaTrackEvent(
          gaCategories.MY_TEAM,
          'Team management > Footer typeform > Admin clicks on typeform link',
        )
      } else {
        Util.gaTrackEvent(
          gaCategories.MY_TEAM,
          'Team management > Footer typeform > Casual user clicks on typeform link',
        )
      }
    },
    isAllowToRemoveThisRole(member) {
      if (member.accountRole === constants.workspace.OWNER) return false
      return true
    },
    openConfirmRemoveMember(member) {
      this.modalRemoveMemberData = member
      this.removeMemberModalVisible = true
      const eventLabel = this.currentAccount.name || ''
      Util.gaTrackEvent(
        gaCategories.MY_TEAM,
        'Team Management > Remove from team',
        eventLabel,
        '',
        {
          plan: this.currentUser.plan,
          isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
        },
      )
    },
    openConfirmLeaveTeam(member) {
      this.modalLeaveTeamData = member
      this.leaveModalMode = member.accountRole ? member.accountRole : constants.workspace.EDITOR
      this.leaveTeamModalVisible = true
      const eventLabel = this.currentAccount.name || ''
      Util.gaTrackEvent(
        gaCategories.MY_TEAM,
        'Team Management > Leave team',
        eventLabel,
        '',
        {
          plan: this.currentUser.plan,
          isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
        },
      )
    },
    handleUpdateInvitationsAndLicense(numberOfInvitedEmails) {
      this.getInvitations()
      if (numberOfInvitedEmails) {
        this.account.numberOfUsedLicenses += numberOfInvitedEmails
      } else {
        this.account.numberOfUsedLicenses--
      }
      this.switchToInvitationsTab()
    },

    copyLink(id) {
      const copyText = document.getElementById(`invitation-link-${id}`)
      /* Select the text field */
      copyText.select()
      copyText.setSelectionRange(0, 99999) /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand('copy')

      /* Alert the copied text */
      Util.showToastSuccess('Link copied!')
    },

    handleShowViewDetail(member) {
      this.mobileViewDetailVisible = true
      this.teamViewDetailData = member
      this.teamViewDetailData.role = this.getCurrentAccountRole(member)
    },
    clickToGetAhaSlidesRequestTeamPlanUpgrade() {
      const href = 'https://form.typeform.com/to/sC0I4AXE'
      window.open(href, '_blank')
      Util.gaTrackEvent(
        gaCategories.MY_TEAM,
        'Request a team plan upgrade',
        this.currentAccount.name,
        '',
        {
          memberCount: this.currentAccount.totalMembers || '?',
          plan: this.currentUser.plan || '?',
          isSelfCreatedTeam: this.currentAccount.createdFrom === 'presenter',
        },
      )
    },
    async updateMemberRole(newRole, member) {
      try {
        const body = await AccountApi.changeMemberRole(
          this.currentUser.accountId,
          member.id,
          {
            accountRole: newRole,
          },
        )
        if (body === 'ok') {
          const updateIndex = this.teamMembers.findIndex((item) => item.id === member.id)
          this.teamMembers[updateIndex].accountRole = newRole
          Util.showToastSuccess('Role updated!')
        } else {
          Util.showToastError('Update role failed!')
        }
      } catch (error) {
        Util.showToastError('Update role failed!')
        if (error.status === 403) window.location.reload()
      }
      EventBus.$emit('memberRoleUpdated')
    },
    getInvitationAccountRole(role) {
      if (role === constants.workspace.OWNER) return 'Owner'
      if (role === constants.workspace.ADMIN) return 'Admin'
      if (role === constants.workspace.EDITOR) return 'Can edit'
      if (role === constants.workspace.VIEWER) return 'Can view'
      return 'Can edit'
    },
    getStatus(status) {
      const result = {
        accepted: 'accepted',
        cancelled: 'cancelled',
        declined: 'declined',
        pending: 'pending',
        expired: 'expired',
        'shareToEdit:claimed': 'claimed',
        'shareToEdit:invited': 'invited',
        'shareToEdit:removed': 'removed',
      }
      return result[status] || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.team-table {
  @apply w-full border-collapse;
}

.team-table tbody tr {
  @apply h-12;
  &:nth-child(odd) {
    background: #F3F4F7;
  }
  > td:first-child {
    @apply rounded-l-lg;
  }
  > td:last-child {
    @apply rounded-r-lg;
  }
  .my-team__col-delete {
    svg {
      visibility: hidden;
    }
    &:hover {
      svg {
        @apply text-primary-90 mr-4;
        float: right;
      }
    }
  }
  &:hover {
    background: #D3E6FD;
    .my-team__col-delete {
      svg {
        @apply mr-4;
        float: right;
        visibility: visible;
      }
    }
  }
}

.team-table .my-team__col-delete {
  @apply p-0;
  min-width: 34px;
}

.team-table td,
.team-table th {
  @apply p-2;
}

.team-table th {
  @apply text-left pt-0;
}

.team-table__truncate {
  @apply overflow-hidden overflow-ellipsis;
  max-width: 2rem;
}

.content--center {
  @apply flex items-center justify-center;
}

.my-team__table-content-wrapper {
  @apply overflow-auto;
}

.my-team__footer-link {
  @apply font-bold text-primary-90;
}

.my-team__col-invitation-link {
  @apply cursor-pointer;

  .invitation-link__input {
    @apply fixed;
    width: 1;
    height: 1;
    left: -999999px;
  }
}

.sm-devices--show {
  @apply hidden sm:table-cell;
}

.lt-sm-devices--show {
  @apply table-cell sm:hidden;
}

@media (max-width: 768px) {
  .my-team__col-invitation-link {
    .icon-copy {
      @apply inline-block;
    }
  }
}
.announcement {
  @apply flex flex-row items-center py-2.5 px-4 my-6 gap-2 rounded-lg relative;
  background: #D3E6FD;
  span {
    @apply mr-4;
  }
  b {
    font-weight: 700;
    color: black;
    text-decoration-line: underline;
  }
}
.pill-admin {
  @apply px-3 py-1 text-sm text-center capitalize cursor-default;
}
</style>
